import React from "react"
import { Box, createStyles, forwardRef } from "@design-system/core"
import { BasicBadgeProps } from "./types"

export const BasicBadge = forwardRef<BasicBadgeProps, "div">((props, ref) => {
  const { type = "attribute", variant = "subtle", style, ...otherProps } = props

  return (
    <Box
      style={[
        styles.root,
        variantStyle[variant]?.[type],
        variant === "icon" && styles.icon,
        style,
      ]}
      {...otherProps}
    />
  )
})

const styles = createStyles((theme) => ({
  root: {
    lineHeight: theme.lineHeights.xSmall,
    paddingVertical: theme.spaces.spacing2,
    paddingHorizontal: theme.spaces.spacing8,
    fontSize: theme.fontSizes.small,
    borderRadius: theme.borderRadii.small,
    display: "inline-block",
  },
  icon: {
    backgroundColor: theme.backgroundColors.default,
    paddingHorizontal: "none",
    alignItems: "center",
  },
}))

const variantStyle = {
  subtle: createStyles((theme) => ({
    attribute: {
      color: theme.colors.gray600,
      backgroundColor: theme.backgroundColors.disabled,
    },
    discount: {
      backgroundColor: theme.backgroundColors.discount,
      color: theme.colors.green600,
    },
    urgent: {
      backgroundColor: theme.backgroundColors.urgent,
      color: theme.colors.red600,
    },
  })),
  solid: createStyles((theme) => ({
    attribute: {
      backgroundColor: theme.colors.gray600,
      color: theme.colors.white,
    },
    discount: {
      backgroundColor: theme.colors.green600,
      color: theme.colors.white,
    },
    urgent: {
      backgroundColor: theme.colors.red600,
      color: theme.colors.white,
    },
  })),
}
